import { required, Create, Edit, SimpleForm, TextInput } from "react-admin";
import { CustomToolbar } from "../../../utils";

const validateRequired = required();

const groupsForm = () => (
  <SimpleForm redirect="list" toolbar={<CustomToolbar />}>
    <TextInput label="Nome" source="name" validate={validateRequired} resettable />
  </SimpleForm>
);

export const GroupsCreate = (props) => (
  <Create redirect="list" title="Novo Grupo" {...props}>
    {groupsForm()}
  </Create>
);

export const GroupsEdit = (props) => (
  <Edit redirect="list" title="Editar Grupo" {...props}>
    {groupsForm()}
  </Edit>
);
